import {
  FilterType,
  SpaceControlWorkSpaceWorkSpaceTypeEnumValues,
  buildGetBookingsDataTableFilter,
  useGetBookingsDataTable,
} from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { workSpaceTypeBackLabel } from 'modules/space_control/store/workSpaceTypes'

const spaceTypeFilter = (source: ReturnType<typeof useGetBookingsDataTable>) => {
  const options = SpaceControlWorkSpaceWorkSpaceTypeEnumValues.map((spaceTypeValue) => {
    return {
      value: spaceTypeValue,
      label: workSpaceTypeBackLabel(spaceTypeValue),
    }
  })

  return buildGetBookingsDataTableFilter(source, {
    type: FilterType.String,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options,
      },
    ],
    identifier: 'spaceTypeFilter',
    path: 'spaceType',
    onUpdateValue: () => {
      track(trackingEvents.spaceControl.bookings.filterBookings, {
        filter_used: 'spaceType',
      })
    },
    title: i18n.t('space_control.my-bookings.datatable.filters.spaceType'),
  })
}
export default spaceTypeFilter
